import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as TrashIcon } from './trash.svg';

export const Trash = IconHOC(TrashIcon);
